import { TextInput, TextInputProps } from './text-input';

export const PercentageInput = (props: TextInputProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <TextInput
        {...props}
        min={0}
        max={100}
        type="number"
        step={0.001}
        css={{
          ...props.css,
          paddingRight: '25px',
        }}
      />
      <span
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: 'inherit',
        }}
      >
        %
      </span>
    </div>
  );
};
